cb.define([], function () {
	var AA_aa_barcoderule_VM_Extend = {

		doAction: function (name, viewmodel) {
			if (this[name]) {
				this[name](viewmodel);
			}
		},
		init: function (viewmodel) {
			var self = this;
			var detailModel = viewmodel.get("barcodeRuleDetail");
			if (detailModel) {
				detailModel.on('afterInsertRow', args => {
					var ruleDetail = viewmodel.get("barcodeRuleDetail");
					if (args.index == 0) {
						ruleDetail.setCellValue(args.index, "iPosition", 1);

					} else {
						var prerow = ruleDetail._get_data('rows')[args.index - 1];
						if (Number(prerow.iPosition) !== 0 && Number(prerow.iLength) !== 0) {
							// args.row.iPosition = (Number(prerow.iPosition) + Number(prerow.iLength)).toString();
							ruleDetail.setCellValue(args.index, "iPosition", Number(prerow.iPosition) + Number(prerow.iLength));
						}
					}
				});

				detailModel.on('rowColChange', function (args) {
					var currentRow = detailModel.getRow(args.value.rowIndex);
					var ruleType = currentRow.cRuleType;
					var colKey = args.value.columnKey;

					if (colKey == 'iPosition') {
						return false;
					}

					if (colKey == 'format') {
						if (ruleType == 7 || ruleType == 8 || ruleType == 9) {
							//'生产日期'||'失效日期' ||'有效期至'
						} else {
							return false;//不能编辑
						}
					} else if (colKey == 'relevant') {
						if (ruleType != 15) {
							return false;
						}
					} else if (colKey == 'iLength') {
						if (ruleType == 7 || ruleType == 8 || ruleType == 9 || ruleType == 15) {
							return false;
						}
					}
				});

				detailModel.on('afterDeleteRows', args => {
					CalcPositions(0);
				});

				// detailModel.on('beforeCellValueChange', function (data) {
				// 	if (data.cellName === 'cRuleType') {

				// 		var rows = detailModel.getRows();
				// 		var storeid = [];
				// 		for (let i = 0; i < rows.length; i++) {
				// 			debugger;
				// 			if (data.rowIndex === i) continue;
				// 			if (data.value.value == rows[i].cRuleType) {
				// 				cb.utils.alert('已存在相同解析类型[' + data.value.text + ']', 'error');
				// 				return false;
				// 			}
				// 		}
				// 	}
				// });

				detailModel.on('afterCellValueChange', function (data) {
					var cellName = data.cellName;
					var childrenField = data.childrenField;
					if (data.value == undefined)
						return;
					var value = data.value;
					var rowindex = data.rowIndex;
					if (childrenField != 'barcodeRuleDetail') return;
					var detailModel = viewmodel.get('barcodeRuleDetail');
					debugger;
					if (cellName == 'cRuleType') {//日期默认格式
						if (value.value == '7' || value.value == '8' || value.value == '9') {
							detailModel.setCellValue(rowindex, 'format', 0);
							detailModel.setCellValue(rowindex, 'iLength', 8);
							CalcPositions(rowindex);
						} else {
							detailModel.setCellValue(rowindex, 'format', undefined);
							detailModel.setCellValue(rowindex, 'iLength', 1);
							CalcPositions(rowindex);
						}
						if (value.value != '15') {
							detailModel.setCellValue(rowindex, 'relevant', undefined);
						}
					} else if (cellName == 'format') {
						detailModel.setCellValue(rowindex, 'iLength', data.value.text.length);
						CalcPositions(rowindex);
						return;
					} else if (cellName == 'relevant') {
						detailModel.setCellValue(rowindex, 'iLength', data.value.length);
						CalcPositions(rowindex);
						return;
						//起始位置改为不可编辑
						// } else if (cellName == 'iPosition') {

						// 	if (!isNaN(value)) {
						// 		if (Number(value) <= 0 || Math.floor(value) !== value) {
						// 			detailModel.setCellValue(rowindex, "iPosition", data.oldValue);
						// 			cb.utils.alert('条码解析规则明细行的起始位置应为大于0的整数','error');
						// 		}
						// 	}
						// 	return;
					} else if (cellName == 'iLength') {

						if (!isNaN(value)) {
							if (Number(value) <= 0 || Math.floor(value) !== value) {
								detailModel.setCellValue(rowindex, "iLength", data.oldValue);
								cb.utils.alert('条码解析规则明细行的长度应为大于0的整数', 'error');
							} else {
								CalcPositions(rowindex);
							}
						}
						return;
					}
				});

				var CalcPositions = function (rowindex) {
					var details = viewmodel.get('barcodeRuleDetail');
					var rows = details.getRows();
					var i = 0;
					details.setCellValue(i, 'iPosition', 1);//第一行的起始位置设为1（删除首行）
					rows[i].iPosition = 1;
					for (i = 1; i < rows.length; i++) {
						if (i > rowindex) {
							if (Number(rows[i - 1].iPosition) !== 0 && Number(rows[i - 1].iLength) !== 0) {
								var newposition = Number(rows[i - 1].iPosition) + Number(rows[i - 1].iLength);
								details.setCellValue(i, 'iPosition', newposition);
								rows[i].iPosition = newposition;//用于循环计算
							} else {
								return;
							}
						}
					}

					CalcTotalLenth();
				};

				var CalcTotalLenth = function(){
					var details = viewmodel.get('barcodeRuleDetail');
					var rows = details.getRows();
					var iTotalLength = 0;
					rows.forEach(item => {
						if (Number(item.iLength) > 0) {
							iTotalLength = iTotalLength + Number(item.iLength);
						}
					});
					
					viewmodel.get('iLength').setValue(iTotalLength);
				}

			}

			viewmodel.on('beforeSave', function (args) {

				return barcoderuledetail(args);

			});

			viewmodel.on('beforeSaveandadd', function (args) {

				return barcoderuledetail(args);
			});


			var barcoderuledetail = function (args) {
				var iHeadLength = viewmodel.get('iLength').getValue();//表头iLength
				var details = viewmodel.get('barcodeRuleDetail');
				var rows = details.getRows();

				var iTotalLength = 0;
				if (iHeadLength <= 0) {
					cb.utils.alert('条码解析规则长度应为大于0的整数!', 'error');
					return false;
				}

				let padMethod = viewmodel.get('padMethod').getValue();
				let paddingChar = viewmodel.get('paddingChar').getValue();

				if((padMethod != null || padMethod != undefined) && (paddingChar == null || paddingChar == undefined)){
					cb.utils.alert('请输入补位符号!','error');
					return false;
				}

				// let relevantIsEmpty = false;
				// rows.forEach(function (item, index) {
				// 	if (Number(item.iLength) > 0)
				// 	{
				// 		iTotalLength = iTotalLength + Number(item.iLength);
				// 	}
				// 	if(item.cRuleType == 15 && item.relevant == undefined){
				// 		relevantIsEmpty = true;
				// 	}
				// })

				for (let i = 0; i < rows.length; i++) {
					let item = rows[i];
					if (item.cRuleType == 15 && (item.relevant == null || item.relevant == '')) {
						cb.utils.alert('固定项的相关值不能为空！', 'error');
						return false;
					}
					if (Number(item.iLength) > 0) {
						iTotalLength = iTotalLength + Number(item.iLength);
					}
				}

				// if(relevantIsEmpty === true){
				// 	cb.utils.alert('固定项的相关值不能为空！','error');
				// 	return false;
				// }

				if (iTotalLength == iHeadLength) {
					return true;
				} else {
					cb.utils.alert('条码解析规则明细总长度不等于表头长度!', 'error');
					return false;
				}

			};

		},

	}
	try {
		module.exports = AA_aa_barcoderule_VM_Extend;
	} catch (error) {

	}
	return AA_aa_barcoderule_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_barcoderule_VM.Extend.js